/* eslint-disable react/prop-types */ // TODO: add props
const KeypadButton = ({ label, onClick, value }) => (
  <button className="button-legacy" value={value || label} onClick={onClick}>
    {label}
  </button>
);

export default KeypadButton;
